import { useState } from 'react';
import { deviceApis } from '../../../../../../shared/apis/device/apis';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, FileInput, Flex, Group, Modal, Text } from '@mantine/core';
import { IconDownload, IconFileTypeXls, IconUpload } from '@tabler/icons-react';
import Swal from 'sweetalert2';
import { notifications } from '@mantine/notifications';
import { queryClient } from '../../../../../../shared/queryClient';
import { queries } from '../../../../../../shared/queries';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export function DeviceExcelRegModal(props: { opened: boolean; close: () => void; header: string }) {
  const { opened, close, header } = props;
  const [file, setFile] = useState<File | null>(null);

  const { mutate: uploadExcel } = useMutation({
    mutationFn: (formData: FormData) => deviceApis.management.uploadExcel(formData),
    onSuccess: () => {
      notifications.show({
        title: '업로드 성공',
        message: '엑셀 파일이 성공적으로 업로드되었습니다.',
        color: 'green',
      });
      queryClient.invalidateQueries(queries.devices.list._def);
      close();
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  const uploadExcelTemplate = async () => {
    const formData = new FormData();
    formData.append('file', file as Blob);
    uploadExcel(formData);
  };

  const onClickClose = () => {
    close();
    setFile(null);
  };

  const getExcelTemplate = async () => {
    try {
      const res = await deviceApis.management.downloadExcel();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '출고등록 템플릿.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: '템플릿 다운로드 실패',
        text: '템플릿 다운로드에 실패했습니다.',
        confirmButtonText: '확인',
      });
    }
  };

  return (
    <Modal opened={opened} onClose={onClickClose} title={header}>
      <Box>
        <Flex direction="column" mb="md">
          <Text size="xs"> ※ 납품처는 Admin &gt; 거래처 메뉴에 등록 후 회사 코드로 입력해주세요.</Text>
        </Flex>
        <FileInput
          clearable
          leftSection={<IconFileTypeXls />}
          label="엑셀 파일 업로드"
          placeholder="파일을 선택하세요."
          accept=".xlsx, .xls"
          leftSectionPointerEvents="none"
          value={file}
          onChange={setFile}
        />
        <Group justify="center" mt="lg">
          <Button
            variant="filled"
            color="secondary.5"
            leftSection={<IconUpload size={16} />}
            onClick={() => {
              uploadExcelTemplate();
            }}
          >
            파일 업로드
          </Button>
          <Button
            variant="outline"
            color="primary.5"
            leftSection={<IconDownload size={16} />}
            onClick={() => {
              getExcelTemplate();
            }}
          >
            탬플릿 다운로드
          </Button>
        </Group>
      </Box>
    </Modal>
  );
}
